import React, { useState } from 'react';
import { useAuth } from '../contextos/AuthProvider'
import TablaDocumentos from './TablaDocumentos';
import { EncApi, EncabezadoPost, EstadosDocumentos, TiposExportacion } from '../Comunes/Listas';
import Swal from 'sweetalert2';

const Encabezados = (props) => {

    const { PerfilUsuario, Token } = useAuth();

    const [Gestor, setGestor] = useState({
        FecDesde: '',
        FecHasta: '',
        NumInterno: '',
        CboEstado: 'ACE',
        Consecutivo: '',
        Cliente: '',
        ckFecha: 'S',
        ckNumInterno: 'N',
        checkEstado: 'N',
        checkConsecutivo: 'N',
        checkCliente: 'N',
        Formatos: 'PDF',
    });

    const Modificar = (e) => {
        const { name, value, type } = e.target;
        console.log(name);
        switch (name) {
            case 'ckFecha':
                setGestor({ ...Gestor, [name]: (Gestor.ckFecha === 'S') ? 'N' : 'S' });
                break;
            case "ckNumInterno":
                setGestor({ ...Gestor, [name]: (Gestor.ckNumInterno === 'S') ? 'N' : 'S' });
                break;
            case "checkEstado":
                setGestor({ ...Gestor, [name]: (Gestor.checkEstado === 'S') ? 'N' : 'S' });
                break;
            case "checkConsecutivo":
                setGestor({ ...Gestor, [name]: (Gestor.checkConsecutivo === 'S') ? 'N' : 'S' });
                break;
            case "checkCliente":
                setGestor({ ...Gestor, [name]: (Gestor.checkCliente === 'S') ? 'N' : 'S' });
                break;
            default:
                setGestor({ ...Gestor, [name]: (type === 'number') ? parseInt(value) : value });
                break;
        }

        //console.log(props.EntidadActual);
    }

    const [DetalleDocs, setDetalleDocs] = useState([]);

    const Descargar = async () => {
         const URL = 'https://smartfecr.com:2017/api/Reportes/ReportesGenerales?BDCompania='
                    + PerfilUsuario.BD
                    + '&IdCia=' + PerfilUsuario.IdCia
                    + '&Doc=ComprasDetalladas' 
                    + '&Formato=' + Gestor.Formatos
                    + '&Desde=' + Gestor.FecDesde
                    + '&Hasta=' + Gestor.FecHasta;
                console.log(URL);
                Swal.fire({
                    title: 'Generando reporte...',
                    text: 'Por favor, espere mientras se genera el documento.',
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading();
                    }
                });
                try {
                    const response = await fetch(URL);
                    const data = await response.json();
        
                    // Determinar el tipo MIME y la extensión del archivo
                    let mimeType = '';
                    let fileExtension = '';
        
                    switch (Gestor.Formatos) {
                        case 'PDF':
                            mimeType = 'application/pdf';
                            fileExtension = '.pdf';
                            break;
                        case 'XLS': //Excel Sin Formato
                            mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                            fileExtension = '.xls';
                            break;
                        case 'XLSS'://Excel Con Formato
                            mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                            fileExtension = '.xls';
                            break;
                        case 'DOC':
                            mimeType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
                            fileExtension = '.doc';
                            break;
                        default:
                            console.error('Formato no soportado:', Gestor.Formatos);
                            return;
                    }
        
                    // Crear y descargar el archivo
                    const tempLink = document.createElement('a');
                    tempLink.href = `data:${mimeType};base64,${data.Result}`;
                    tempLink.setAttribute('download', 'Reporte_Compras'  + fileExtension);
                    tempLink.click();
                    Swal.close();
        
                } catch (error) {
        
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'No se pudo generar el reporte.',
                        confirmButtonText: 'Aceptar'
                    });
                }
            }
    

    const Consultar = async () => {
        const url = 'https://smartfecr.com:2020/SmartContrackBack/api/DocumentosElectronicos/TablaDocumentosApi';
        let GestorEnviar = {
            BdCia: PerfilUsuario.BD,
            CkNumDoc: Gestor.ckNumInterno === 'N' ? 0 : parseInt(Gestor.NumInterno),
            CboEstado: Gestor.checkEstado === 'N' ? "TOD" : Gestor.CboEstado,
            CboTipDoc: props.TipoDoc,
            ConFechas: Gestor.ckFecha,
            FecDesde: Gestor.FecDesde,
            FecHasta: Gestor.FecHasta,
            Consecutivo: Gestor.checkConsecutivo === 'N' ? 'NO' : Gestor.Consecutivo,
            Cliente: Gestor.checkCliente === 'N' ? "NO" : Gestor.Cliente,
            Ambiente: PerfilUsuario.IdCia !== 1,
            Actividad: "",
        };
        console.log(GestorEnviar);
        await fetch(url, EncabezadoPost(Token, GestorEnviar)).then(response => response.json())
            .then(json => {
                console.log(json);
                if (json.errors) {
                    let errorMessages = Object.values(json.errors).flat().join(', ');
                    Swal.fire({
                        icon: 'error',
                        title: 'Alerta...',
                        text: errorMessages,
                    });
                    return;
                }
                if (json.Nota === 'OK') {
                    setDetalleDocs(json.Lineas);
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Alerta...',
                        text: json.Nota
                    })
                }
            })
    }

    React.useEffect(() => {
        const fetchHoraServidor = async () => {
            try {
                const response = await fetch('https://smartfecr.com:2020/SmartContrackBack/api/Companias/HoraServidor', EncApi(Token));
                const data = await response.json();
                console.log(data);
                setGestor({ ...Gestor, FecDesde: data.Fecha, FecHasta: data.Fecha });
            } catch (error) {
                console.error('Error fetching server time:', error);
            }
        };

        fetchHoraServidor();
        // eslint-disable-next-line
    }, []);

    if (PerfilUsuario) {
        return (
            <>
                <div className="row">
                    <div className="col-50">
                        <div className='row'>

                            <div className="col-25">
                                <input type="checkbox" name='ckFecha' id='ckFecha' checked={Gestor.ckFecha === 'S'} onChange={Modificar} />
                                <span className="col-form-span">Desde </span>

                                <input type="date" id="FecDesde" name="FecDesde" autoComplete='off' value={Gestor.FecDesde} onChange={Modificar}></input>
                            </div>


                            <div className="col-25">
                                <span className="col-form-span">Al Día </span>
                                <input type="date" id="FecHasta" name="FecHasta" autoComplete='off' value={Gestor.FecHasta} onChange={Modificar}></input>
                            </div>
                            <div className="col-25">
                                <input type="checkbox" name='ckNumInterno' id='ckNumInterno' checked={Gestor.ckNumInterno === 'S'} onChange={Modificar} />
                                <span className="col-form-span">Número Interno </span>
                                <input type="text" id="NumInterno" name="NumInterno" autoComplete='off' value={Gestor.NumInterno} onChange={Modificar}></input>
                            </div>
                        </div>
                    </div>
                    <div className="col-50">
                        <div className='row'>
                            <div className="col-25">
                                <input type="checkbox" name='checkEstado' id='checkEstado' checked={Gestor.checkEstado === 'S'} onChange={Modificar} />
                                <span className="col-form-span">Estado </span>
                                <select id="CboEstado" name="CboEstado" className="form-group" onChange={Modificar} value={Gestor.CboEstado}>
                                    {EstadosDocumentos.map((option, i) => (
                                        <option key={i} value={option.value}>{option.span}</option>
                                    ))}</select>
                            </div>

                            <div className="col-25">
                                <input type="checkbox" name='checkConsecutivo' id='checkConsecutivo' checked={Gestor.checkConsecutivo === 'S'} onChange={Modificar} />
                                <span className="col-form-span">Consecutivo </span>
                                <input type="text" id="Consecutivo" name="Consecutivo" autoComplete='off' value={Gestor.Consecutivo} onChange={Modificar}></input>
                            </div>


                            <div className="col-25">
                                <input type="checkbox" name='checkCliente' id='checkCliente' checked={Gestor.checkCliente === 'S'} onChange={Modificar} />
                                <span className="col-form-span"> Nombre socio comercial </span>
                                <input type="text" id="Cliente" name="Cliente" autoComplete='off' value={Gestor.Cliente} onChange={Modificar}></input>
                            </div>
                            <div className="col-25">
                                <button className="boton" style={{ minWidth: '60px' }} onClick={() => Consultar()}>Consultar</button>
                            </div>
                        </div>
                    </div>
                </div>
                {props.TipoDoc === 'COM' ? (
                    <div className='row'>
                        <div className='col-25'>
                                <span className="col-form-span">Formato </span>
                                <select id="Formatos" name="Formatos" className="form-group"
                                    onChange={Modificar} value={Gestor.Formatos}>
                                    {TiposExportacion.map((option, i) => (
                                        <option key={i} value={option.value}>{option.span}</option>
                                    ))}
                                </select>
                            </div>
                        <div className="col-25">
                            <button className="boton" style={{ minWidth: '60px' }} onClick={() => Descargar()}>Descargar Compras</button>
                        </div>
                        <div className="col-50"></div>
                    </div>
                ) : null}

                <TablaDocumentos DetalleDocs={DetalleDocs} TipoDoc={props.TipoDoc} idCia={PerfilUsuario.IdCia} />
            </>
        )
    }
    else {
        return (<p>Cargando Información...</p>)
    }
};

export default Encabezados;